import "./App.css";
import { useEffect, type ReactNode } from "react";
// import LandingPage from './components/LandingPage/LandingPage';
import SchedulePage from "./components/SchedulePage/schedulePage";
import { Container } from "react-bootstrap";
import LeaguePage from "./components/League/League";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	useLocation,
} from "react-router-dom";
// import SignInSignUpModal from './components/SignInSignUpModal/SignInSignUpModal';
import { GoogleOAuthProvider } from "@react-oauth/google";

import AdminPage from "./components/AdminPage/AdminPage";
import "./custom-bootstrap.scss";
import "./styles/modal-theme.css";
import Navbar from "./components/Navbar/Navbar";
import FantasyPage from "./components/Fantasy/FantasyMain";
import EditTeamPage from "./components/EditTeam/EditTeamPage";
import AdminSportsPage from "./components/AdminPage/AdminSportsPage";
import AdminEventsPage from "./components/AdminPage/AdminEventsPage";
import AdminRidersPage from "./components/AdminPage/AdminRidersPage";
import ResetPasswordPage from "./components/LoginPage/ResetPassword";
import ForgotPassword from "./components/LoginPage/ForgotPassword";
import AdminLeaguesPage from "./components/AdminPage/AdminLeaguesPage";
import EditUserProfile from "./components/ProfilePage/UserProfile";
import AdminSnapshotForm from "./components/AdminPage/AdminSnapshots";
import VideoAdminPage from "./components/AdminPage/AdminVideosPage";
import AdminResultsPage from "./components/AdminPage/AdminResultPage";
import RankingPage from "./components/RankingsPage/RankingPage";
import Footer from "./components/Footer/Footer";
import PrivacyPolicyPage from "./components/Footer/PrivacyPolicy";
import ContactUs from "./components/Footer/ContactUs";
import AboutUsPage from "./components/Footer/AboutUsPage";
import AdminUsersPage from "./components/AdminPage/AdminUsersPage";
import AdminAdManagerPage from "./components/AdminPage/AdminAdManager";
import Watch from "./components/WatchPage/Watch";
import AdminWatchManager from "./components/AdminPage/AdminWatchManager";
import TermsComponent from "./components/Footer/TermsAndConditions";
import ReactGA from "react-ga4";
import AdminDisableManager from "./components/AdminPage/AdminDisableManager";
import AdminSeasonsPage from "./components/AdminPage/AdminSeasonsPage";
import AdminBrandTeamPage from "./components/AdminPage/AdminBrandTeamPage";
import AdminBlogsPage from "./components/AdminPage/AdminBlogsPage";
import AdminPrizesPage from "./components/AdminPage/AdminPrizesPage";
import AdminUploadRidersPage from "./components/AdminPage/AdminUploadRidersPage";
import NewsPage from "./components/NewsPage/NewsPage";
import NewsArticlePage from "./components/NewsPage/NewsArticlePage";
import EventsBar from "./components/Events/EventsBar";
import Teams from "./components/Teams/Teams";
import HowToPlay from "./components/HowToPlay/HowToPlay";
import AdminAnalyticsPage from "./components/AdminPage/AdminAnalyticsPage";
import AdminFeaturedPage from "./components/AdminPage/AdminFeaturedPage";
import HomePage from "./components/HomePage/HomePage";
import RidersPage from "./components/Rider/RidersPage";
import AthleteProfilePage from "./components/Rider/AthleteProfilePage";
import SelectDisciplinePage from "./components/SelectDiscipline/SelectDisciplinePage";
import { useAppSelector } from "./store/hooks";
import { RootState } from "./store/store";

const chromeHiddenRoutes = new Set(["/selectdiscipline", "/select-discipline"]);

const shouldHideChrome = (pathname: string) =>
	chromeHiddenRoutes.has(pathname.toLowerCase());

const AppChrome = ({ children }: { children: ReactNode }) => {
	const location = useLocation();
	const hideChrome = shouldHideChrome(location.pathname);

	return (
		<>
			{!hideChrome ? (
				<>
					<Navbar />
					<EventsBar />
				</>
			) : null}
			{children}
		</>
	);
};

const AppFooter = () => {
	const location = useLocation();
	return shouldHideChrome(location.pathname) ? null : <Footer />;
};

function App() {
	ReactGA.initialize(process.env.REACT_APP_GA4_ID ?? "");
	const appThemeClass = "theme-dark";
	const { selectedSport } = useAppSelector((state: RootState) => state.fantasy);
	const selectedSportName = selectedSport?.name?.toLowerCase() ?? "";
	const selectedSportShortName = selectedSport?.shortName?.toLowerCase() ?? "";
	const isCrossCountrySport =
		selectedSportName.includes("cross country") ||
		selectedSportName.includes("cross-country") ||
		selectedSportName === "xc" ||
		selectedSportName.includes("xco") ||
		selectedSportShortName === "xc" ||
		selectedSportShortName === "xco" ||
		selectedSportShortName.includes("xc");
	const isSlopestyleSport =
		selectedSportName.includes("slopestyle") || selectedSportShortName === "ss";
	const isEnduroSport = selectedSportName.includes("enduro");
	const isFreerideSport =
		selectedSportName.includes("freeride") ||
		selectedSportName.includes("rampage");

	const sportThemeClass = isCrossCountrySport
		? "sport-theme--cross-country"
		: isSlopestyleSport
			? "sport-theme--slopestyle"
			: isEnduroSport
				? "sport-theme--enduro"
				: isFreerideSport
					? "sport-theme--freeride"
					: "sport-theme--downhill";

	const backgroundTintClass = isCrossCountrySport
		? "background-image-tint--cross-country"
		: isSlopestyleSport
			? "background-image-tint--slopestyle"
			: isEnduroSport
				? "background-image-tint--enduro"
				: isFreerideSport
					? "background-image-tint--freeride"
					: "background-image-tint--downhill";

	const backgroundImageClass = `background-image ${backgroundTintClass}${
		isCrossCountrySport ? " background-image--cross-country" : ""
	}`;

	useEffect(() => {
		if (typeof window === "undefined") {
			return;
		}
		window.localStorage.setItem("themePreference", "dark");
		document.body.classList.remove("theme-light");
		document.body.classList.add("theme-dark");
	}, []);

	return (
		<Router>
			<div className={appThemeClass}>
				<GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID ?? ""}>
					<Container
						fluid
						className={`page-wrapper px-0 mx-0 ${appThemeClass} ${sportThemeClass}`}
					>
					<div className={backgroundImageClass} />
					<Container fluid className="content-wrapper position-relative px-0 ">
						<AppChrome>
						<Routes>
							{/* <Route
								path="/login"
								element={
									<LoginPage
										handleSignIn={handleSignIn}
										handleSignUp={handleSignUp}
										handleGoogleSignIn={handleGoogleSignIn}
									/>
								}
							/> */}
							{/* <Route path="/" element={<HoldingPage />} /> */}
							<Route path="/" element={<HomePage />} />
							<Route path="/selectdiscipline" element={<SelectDisciplinePage />} />
							<Route
								path="/select-discipline"
								element={<SelectDisciplinePage />}
							/>
							{/* <Route path="/" element={<HomePage />} /> */}
							{/* <Route path="/home" element={<HomePage />} /> */}
							<Route path="/schedule" element={<SchedulePage />} />
							<Route path="/news" element={<NewsPage />} />
							<Route path="/news/:slug" element={<NewsArticlePage />} />
							<Route path="/fantasy" element={<FantasyPage />} />
							<Route path="watch" element={<Watch />} />
							<Route path="/league/:leagueId" element={<LeaguePage />} />
							<Route path="/editprofile" element={<EditUserProfile />} />
							<Route path="/howtoplay" element={<HowToPlay />} />

							<Route
								path="/editTeam/:teamId?/:leagueId?/:sport?/:series?"
								element={<EditTeamPage />}
							/>
							<Route
								path="/resetpassword/:token"
								element={<ResetPasswordPage />}
							/>
							<Route path="about" element={<AboutUsPage />} />
							<Route path="/rankings" element={<RankingPage />} />
							<Route path="/forgotpassword" element={<ForgotPassword />} />
							<Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
							<Route path="/termsandconditions" element={<TermsComponent />} />
							<Route path="/teams" element={<Teams />} />
							<Route path="/riders" element={<RidersPage />} />
							<Route path="/riders/:riderId" element={<AthleteProfilePage />} />
							<Route path="contact" element={<ContactUs />} />
							<Route path="/admin" element={<AdminPage />} />
							<Route path="/admin/riders" element={<AdminRidersPage />} />
							<Route path="/admin/teams" element={<AdminPage />} />
							<Route path="/admin/leagues" element={<AdminLeaguesPage />} />
							<Route path="/admin/events" element={<AdminEventsPage />} />
							<Route path="/admin/results" element={<AdminResultsPage />} />
							<Route path="/admin/sports" element={<AdminSportsPage />} />
							<Route path="/admin/snapshots" element={<AdminSnapshotForm />} />
							<Route path="/admin/videos" element={<VideoAdminPage />} />
							<Route path="/admin/users" element={<AdminUsersPage />} />
							<Route path="/admin/admanager" element={<AdminAdManagerPage />} />
							<Route path="/admin/watch" element={<AdminWatchManager />} />
							<Route path="/admin/disable" element={<AdminDisableManager />} />
							<Route path="/admin/seasons" element={<AdminSeasonsPage />} />
							<Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
							<Route path="/admin/blogs" element={<AdminBlogsPage />} />
							<Route path="/admin/prizes" element={<AdminPrizesPage />} />
							<Route path="/admin/featured" element={<AdminFeaturedPage />} />
							<Route
								path="/admin/upload-riders"
								element={<AdminUploadRidersPage />}
							/>
							<Route
								path="/admin/brandteams"
								element={<AdminBrandTeamPage />}
							/>
						</Routes>
						</AppChrome>
					</Container>
					</Container>
					<AppFooter />
				</GoogleOAuthProvider>
			</div>
		</Router>
	);
}

export default App;
